import { render } from "./DefaultFilter.vue?vue&type=template&id=0bc63484&scoped=true"
import script from "./DefaultFilter.vue?vue&type=script&lang=js"
export * from "./DefaultFilter.vue?vue&type=script&lang=js"

import "./DefaultFilter.vue?vue&type=style&index=0&id=0bc63484&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc63484"]])

export default __exports__